<!-- =========================================================================================
	File Name: ItemGridView.vue
	Description: Item Component - Grid VIew
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- <div class="item-grid-view vx-row match-height">
  <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID">-->
  <vx-card class="grid-view-item mb-base overflow-hidden">
    <template slot="no-body">
      <!-- ITEM IMAGE -->
      <div class="item-img-container bg-white h-64 flex items-center justify-center mb-4">
        <img
          :src="item.image ? item.image : require(`@/assets/images/pages/no-image.png`)"
          :alt="item.name"
          class="grid-view-img px-4"
        />
      </div>
      <div class="item-details px-4">
        <!-- RATING & PRICE -->
        <div class="flex justify-between items-center">
          <!-- <div class="flex text-white py-1 px-2 rounded" :class="item.source ? 'bg-success' : 'bg-danger'">
            <span class="text-sm mr-2">{{ item.source ? item.source.length : 0 }}</span>
            <feather-icon icon="LinkIcon" svgClasses="h-4 w-4"/>
          </div> -->
          <h6 class="font-bold mr-5" v-if="item.price !== '0'">{{ item.price | numFormat('$ 0,0.0') }}</h6>
          <h6 v-else>.</h6>
          <div>
            <span class="flex -mr-1" v-if="item.bestPrice !== 0">
              <span class="mr-1" :class="item.bestPrice === nextBestPrice ? 'text-grey' : ''">{{ (item.pos === 'down' ? item.bestPrice : nextBestPrice) | numFormat('$ 0,0.0')}}</span>
              <feather-icon :icon=" item.pos === 'down' ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[item.bestPrice === nextBestPrice ? 'text-grey' : (item.pos === 'down' ? 'text-danger' : 'text-success')  ,'stroke-current h-4 w-4 mb-1 mr-1 font-bold']" v-if="item.bestPrice !== nextBestPrice"></feather-icon>
            </span>
            <span v-else>.</span>
          </div>
        </div>

        <!-- TITLE & DESCRIPTION -->
        <div class="my-4">
          <h6 class="truncate font-semibold mb-1">{{ item.name }}</h6>
          <div class="flex justify-between items-center">
            <div class="flex text-white py-1 px-2 rounded" :class="item.source ? 'bg-success' : 'bg-danger'">
            <span class="text-sm mr-2">{{ item.source ? item.source.length : 0 }}</span>
            <feather-icon icon="LinkIcon" svgClasses="h-4 w-4"/>
          </div>
            <!-- <div>
              <span class="flex -mr-1" v-if="item.bestPrice !== 0">
                <span class="mr-1">{{ item.bestPrice | numFormat('$ 0,0')}}</span>
                <feather-icon :icon=" item.pos === 'down' ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[item.pos === 'down' ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
              </span>
            </div> -->
            <div>
              <vue-apex-charts
                :name="'competitor-'+item.code"
                type="bar"
                height="35"
                width="100"
                :options="sparkLine"
                :series="seriesSpark(item)"
              />
            </div>
          </div>
          <!-- <p class="item-description truncate text-sm" v-for="source in item.source" :key="source.name">
            <vs-chip>
              <vs-avatar icon-pack="feather" :icon="source.pos === 'down' ? 'icon-arrow-down' : 'icon-arrow-up'"/>
              <span>{{source.name}} # <sup class="text-base mr-1">{{currency}}</sup> {{source.price }}</span>
            </vs-chip>
          </p>-->
        </div>
      </div>

      <!-- SLOT: ACTION BUTTONS -->
      <slot name="action-buttons" />
    </template>
  </vx-card>
  <!--  </div>
  </div>-->
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    VueApexCharts
  },
  data() {
    return {
      sparkLine: {
        chart: {
          height: 35,
          width: 100,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            columnWidth: "80%"
          }
        },
        colors: themeColors,
        stroke: {
          curve: "straight"
          // width: [1]
        },
        fill: {
          opacity: 0.3
        },
        xaxis: {
          crosshairs: {
            width: 1
          }
        },
        tooltip: {
          fixed: {
            enabled: false
          },
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function(seriesName) {
                return "";
              }
            }
          },
          marker: {
            show: false
          },
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="p-3" style="white-space: pre-wrap !important; max-width: 150px;">' +
              "<div><small>" +
              w.config.series[seriesIndex].name[dataPointIndex] +
              "</small></div>" +
              "<div><small>" +
              w.config.series[seriesIndex].data[dataPointIndex] +
              "</small></div>" +
              "</div>"
            );
          }
        }
      },
      nextBestPrice: '0.0'
    };
  },
  methods: {
    seriesSpark(data) {
      let series = [
        {
          name: [],
          data: []
        }
      ];

      let tempOtherPrices = []

      // series[0].name.push("Our Price");
      // series[0].data.push(data.price);

      for (let i = 0; i < (data.source ? data.source.length : 0); i++) {
        if (data.source[i].price && data.source[i].price !== "0") {
          series[0].name.push(data.source[i].name);
          series[0].data.push(data.source[i].price);

          if(this.item.bestPrice !== Number(data.source[i].price)){
            tempOtherPrices.push(data.source[i].price)
          }
        }
      }

      if(tempOtherPrices.length === 0) {
        tempOtherPrices.push(this.item.bestPrice)
      }

      const sortedOtherPrices = [...new Float64Array(tempOtherPrices).sort()];

      this.nextBestPrice = sortedOtherPrices[0];

      return series;
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-view-item {
  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>